<div class="visible-lg">
  <div class="flex-container">
    <div class="bmw-bulletin-container flex-60">
      <div class="bmw-bulletin-title">
        {{getPageTitle()}}
      </div>
      <!-- <form #formeditnoisecatalog="ngForm" (ngSubmit)="onSubmit(formeditnoisecatalog)"> -->
      <form #formeditnoisecatalog="ngForm"
        (ngSubmit)="formeditnoisecatalog.form.valid && onSubmit(formeditnoisecatalog)" novalidate>
        <div *ngIf='bulletinType === "noise catalog" && actionType === "edit"'>
          <div  class="flex-container">
            <div class="flex-25">
              <ng-container
                *ngIf="( (makeSelectedField.touched || formeditnoisecatalog.submitted) && makeSelectedField.errors?.defaultSelected); then mandatoryMake; else optionalMake">
              </ng-container>
              <ng-template #mandatoryMake>
                <div>
                  <label class="text-danger">Make*</label>
                </div>
              </ng-template>
              <ng-template #optionalMake>
                <div>
                  <label>Make*</label>
                </div>
              </ng-template>
              <!-- <em
              *ngIf="formeditnoisecatalog.controls.makeSelected?.invalid && (formeditnoisecatalog.controls.makeSelected?.touched || mouseoverLogin)">Required</em> -->
              <!-- <div class="bmw-cms-new-bulletin-select"> -->
              <select class="form-control" appSelectValidator="undefined" #makeSelectedField id="makeSelected"
                name="makeSelected" [ngModel]="makeSelected"
                (ngModelChange)="makeSelectedField.value = onMakeSelectionChanged($event)" style="width:80%;"
                [class.field-error]="formeditnoisecatalog.submitted && makeSelectedField.invalid">
                <option ngValue="undefined" disabled selected> Select</option>
                <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
                <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>
                <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
                <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
              </select>
              <!-- </div> -->
            </div>
            <div class="flex-25">
              <ng-container
                *ngIf="( (noiseCatalogField.touched && formeditnoisecatalog.submitted) && noiseCatalogField.errors?.defaultSelected && inputMake!==null); then mandatoryNoiseCatalog; else optionalNoiseCatalog">
              </ng-container>
              <ng-template #mandatoryNoiseCatalog>
                <div>
                  <label class="text-danger">Noise Catalog Number*</label>
                </div>
              </ng-template>
              <ng-template #optionalNoiseCatalog>
                <div>
                  <label>Noise Catalog Number*</label>
                </div>
              </ng-template>
              <!-- <div class="bmw-cms-new-bulletin-select"
                [class.has-error]="(noiseCatalogField.touched || formeditnoisecatalog.submitted) && noiseCatalogField.errors?.defaultSelected"> -->
              <select class="form-control" #noiseCatalogField="ngModel" appSelectValidator="undefined" id="noiseCatalog"
                name="noiseCatalog" [(ngModel)]='noiseCatalogNumber' style="width:80%;"
                (ngModelChange)="getNoiseCatalogData(noiseCatalogNumber, makeSelected)">
                <option ngValue="undefined" disabled selected> Select</option>
                <option *ngFor="let noiseCatalogNumber of NoiseCatalogNumbersList"
                  [ngValue]="noiseCatalogNumber.noiseCatalogDisplayNumber" data-toggle="tooltip"
                  data-container="#tooltip_container" [title]="noiseCatalogNumber.noiseCatalogTitle">
                  {{noiseCatalogNumber.noiseCatalogDisplayNumber}}
                </option>
              </select>
              <span *ngIf='showAllFields == true'>
                <!-- <small style="color: red">Min. length 6 characters</small> -->
                <small style="font-weight: bold;" [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
                  {{isDocActive ? "Active" : "In-active"}}
                </small>
              </span>
              <!-- <small style="font-weight: bold;margin-left: 10px"
                  [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}' *ngIf='showAllFields == true'>
                  {{isDocActive ? "Active" : "In-active"}}
                </small> -->
              <div id="tooltip_container"></div>

              <!-- </div> -->
            </div>
            <div class="flex-50" *ngIf='showAllFields == true'>
              <ng-container
                *ngIf="( (mainGroupField.touched && formeditnoisecatalog.submitted) && mainGroupField.errors?.defaultSelected && inputMake!==null); then mandatoryGroup; else optionalGroup">
              </ng-container>
              <ng-template #mandatoryGroup>
                <div>
                  <label class="text-danger">Main Group*</label>
                </div>
              </ng-template>
              <ng-template #optionalGroup>
                <div>
                  <label>Main Group*</label>
                </div>
              </ng-template>
              <select class="form-control" #mainGroupField="ngModel" appSelectValidator="undefined" id="mainGroup"
                name="mainGroup" [(ngModel)]='inputChannel' style="width:80%;">
                <option ngValue="undefined" disabled selected> Select</option>
                <option *ngFor="let mainGroup of channelsList"
                  [selected]="mainGroup.mainGroupName === inputChannel.mainGroupName" [ngValue]="mainGroup">
                  [{{mainGroup?.mainGroupNumber}}] {{mainGroup?.mainGroupName}}
                </option>
              </select>
            </div>
          </div>
          <div *ngIf='showAllFields == true'>
            <!-- <small style="font-weight: bold;margin-left: 10px"
              [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
              {{isDocActive ? "Active" : "In-active"}}
            </small> -->
            <div  class="flex-container">
              <div class="flex-25">
                <ng-container
                  *ngIf="( (sporadicPermanentField.touched && formeditnoisecatalog.submitted) && sporadicPermanentField.errors?.defaultSelected && inputMake!==null); then mandatorySporadicPermanent; else optionalSporadicPermanent">
                </ng-container>
                <ng-template #mandatorySporadicPermanent>
                  <div>
                    <label class="text-danger">Sporadic or Permanent*</label>
                  </div>
                </ng-template>
                <ng-template #optionalSporadicPermanent>
                  <div>
                    <label>Sporadic or Permanent*</label>
                  </div>
                </ng-template>
                <select class="form-control" #sporadicPermanentField="ngModel" appSelectValidator="undefined"
                  id="sporadicPermanent" name="sporadicPermanent" [(ngModel)]='inputSproadicPermanent'
                  style="width:80%;">
                  <option ngValue="undefined" disabled selected> Select</option>
                  <option *ngFor="let sproadicPermanent of sproadicPermanentList" [ngValue]="sproadicPermanent">
                    {{sproadicPermanent}}
                  </option>
                </select>
                <!-- <span class="text-danger"
                  *ngIf="(sporadicPermanentField.touched || formeditnoisecatalog.submitted) && sporadicPermanentField.errors?.defaultSelected">
                  *Required
                </span> -->
                <!-- </div> -->
              </div>
              <div class="flex-25">
                <ng-container
                  *ngIf="( ( formeditnoisecatalog.submitted) && mydateField.errors?.required && inputMake!==null); then mandatoryDate; else optionalDate">
                </ng-container>
                <ng-template #mandatoryDate>
                  <div>
                    <label class="text-danger">Date*</label>
                  </div>
                </ng-template>
                <ng-template #optionalDate>
                  <div>
                    <label>Date*</label>
                  </div>
                </ng-template>
                <div>
                  <input type="date" name="mydate" id="mydate" [(ngModel)]="inputDate" class="form-control" required />
                  <!-- <span class="text-danger" *ngIf="( formeditnoisecatalog.submitted) && mydateField.errors?.required">
                  *Required
                </span> -->
                </div>
              </div>
              <div class="flex-25">
                <label>Related SIB</label>
                <input #relatedSIB id="relatedSIB" name="relatedSIB" [(ngModel)]='bulletinNumber' type="text"
                  maxlength="8" (keyup)="formatBulletinNumber($event, 'sib')" placeholder="00 00 00">
              </div>
              <i class="material-icons dp48 pointer" style="font-size: 30px;margin-left: -25px;line-height:3"
                (click)='addToSelection("sib", bulletinNumber)'>add_box</i>

              <i style="line-height:6" *ngIf="errorMessageSIB!==''">
                <small style="color: red" *ngIf="errorMessageSIB!==''">{{errorMessageSIB}}</small>
              </i>

            </div>
            <!-- <div  class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='relatedSIBs?.length > 0'>
          </div> -->
            <div  class="flex-container">
              <div class="bmw-model-chips" style="margin-left: 50%">
                <div class="bmw-bulletin-series-chips" *ngFor='let bulletin of relatedSIBs'>
                  {{bulletin}}
                  <i class="material-icons" (click)='removeFromSelection("sib", bulletin)'>close</i>
                </div>
              </div>
            </div>
            <div  class="flex-container">
              <div class="flex-87">
                <ng-container
                  *ngIf="( formeditnoisecatalog.submitted && noiseCatalogTitleField.errors?.required &&  inputMake!==null); then mandatoryNoiseCatalogTitle; else optionalNoiseCatalogTitle">
                </ng-container>
                <ng-template #mandatoryNoiseCatalogTitle>
                  <div>
                    <label class="text-danger">Noise Catalog Title*</label>
                  </div>
                </ng-template>
                <ng-template #optionalNoiseCatalogTitle>
                  <div>
                    <label>Noise Catalog Title*</label>
                  </div>
                </ng-template>
                <div>
                  <!-- <em
                  *ngIf="formeditnoisecatalog.controls.noiseCatalogTitle?.invalid && (formeditnoisecatalog.controls.noiseCatalogTitle?.touched || mouseoverLogin)">Required</em> -->
                  <input type="text" id="noiseCatalogTitle" name="noiseCatalogTitle" #noiseCatalogTitleField="ngModel"
                    required [(ngModel)]="textareaContent">
                  <!-- <span class="text-danger"
                  *ngIf="( formeditnoisecatalog.submitted) && noiseCatalogTitleField.errors?.required">
                  *Required
                </span> -->
                </div>
                <!-- <div [hidden]="!formeditnoisecatalog.submitted || noiseCatalogTitle.valid" class="alert alert-danger">
                Enter Noise Catalog Title.
              </div> -->
              </div>
            </div>
            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>E Series</label><br />
                <ng-multiselect-dropdown #multiSelectSeries id="multiSelectSeries" name="multiSelectSeries"
                  [placeholder]="'Select'" [data]="dropdownESeriesList" [(ngModel)]="seriesFilterList"
                  [settings]="dropdownSettingsSeries" [disabled]="false"
                  (onSelect)='addToNoiseSelection("series",$event)'
                  (onDeSelect)='removeFromNoiseSelection("series",$event)'>
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div  class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
                  {{ series.seriesName }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i> -->
                </div>
              </div>
            </div>
            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>Area</label><br />
                <ng-multiselect-dropdown #multiSelectArea id="multiSelectArea" name="multiSelectArea"
                  [placeholder]="'Select'" [data]="dropdownAreaList" [(ngModel)]="areaFilterList"
                  [settings]="dropdownSettingsArea" (onSelect)='addToNoiseSelection("area",$event)'
                  (onDeSelect)='removeFromNoiseSelection("area",$event)'>
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div  class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let area of areaFilterList'>
                  {{ area.signalName }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("area", area)'>close</i> -->
                </div>
              </div>
            </div>

            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>Component</label><br />
                <ng-multiselect-dropdown #multiSelectComponent id="multiSelectComponent" name="multiSelectComponent"
                  [placeholder]="'Select'" [data]="dropdownComponentList" [(ngModel)]="componentFilterList"
                  [settings]="dropdownSettings" (onSelect)='addToNoiseSelection("component",$event)'
                  (onDeSelect)='removeFromNoiseSelection("component",$event)'>
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div  class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let component of componentFilterList'>
                  {{ component }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("component", component)'>close</i> -->
                </div>
              </div>
            </div>

            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>Driving Conditions</label><br />
                <ng-multiselect-dropdown #multiSelectDrivingCondition id="multiSelectDrivingCondition"
                  name="multiSelectDrivingCondition" [placeholder]="'Select'" [data]="dropdownDrivingConditionList"
                  [(ngModel)]="drivingConditionFilterList" [settings]="dropdownSettings"
                  (onSelect)='addToNoiseSelection("drivingCondition",$event)'
                  (onDeSelect)='removeFromNoiseSelection("drivingCondition",$event)'>
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div  class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let drivingCondition of drivingConditionFilterList'>
                  {{ drivingCondition }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("drivingCondition", drivingCondition)'>close</i> -->
                </div>
              </div>
            </div>

            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>Weather Conditions</label><br />
                <ng-multiselect-dropdown #multiSelectWeatherCondition id="multiSelectWeatherCondition"
                  name="multiSelectWeatherCondition" [placeholder]="'Select'" [data]="dropdownWeatherConditionList"
                  [(ngModel)]="weatherConditionFilterList" [settings]="dropdownSettings"
                  (onSelect)='addToNoiseSelection("weatherCondition",$event)'
                  (onDeSelect)='removeFromNoiseSelection("weatherCondition",$event)'
                  (onDropDownClose)="onDropDownClose($event)">
                  >
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div  class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let weatherCondition of weatherConditionFilterList'>
                  {{ weatherCondition }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("weatherCondition", weatherCondition)'>close</i> -->
                </div>
              </div>
            </div>

            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-70">
                <label>Kind of Noise</label><br />
                <ng-multiselect-dropdown #multiSelectKindOfNoise id="multiSelectKindOfNoise"
                  name="multiSelectKindOfNoise" [placeholder]="'Select'" [data]="dropdownKindOfNoiseList"
                  [(ngModel)]="kindOfNoiseFilterList" [settings]="dropdownSettings"
                  (onSelect)='addToNoiseSelection("kindOfNoise",$event)'
                  (onDeSelect)='removeFromNoiseSelection("kindOfNoise",$event)'
                  (onDropDownClose)="onDropDownClose($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>

            <div  class="flex-container">
              <div>
                <div class="bmw-bulletin-series-chips" *ngFor='let kindOfNoise of kindOfNoiseFilterList'>
                  {{ kindOfNoise }}
                  <!-- <i class="material-icons" (click)='removeFromSelection("kindOfNoise", kindOfNoise)'>close</i> -->
                </div>
              </div>
            </div>


            <div  class="flex-container" style="margin-top: 20px">
              <div class="flex-87">
                <ng-container
                  *ngIf="( formeditnoisecatalog.submitted && vimeoIDField.errors?.required && inputMake!==null); then mandatoryVimeoId; else optionalVimeoId">
                </ng-container>
                <ng-template #mandatoryVimeoId>
                  <div>
                    <label class="text-danger">Vimeo ID*</label>
                  </div>
                </ng-template>
                <ng-template #optionalVimeoId>
                  <div>
                    <label>Vimeo ID*</label>
                  </div>
                </ng-template>
                <div>
                  <input type="text" #vimeoIDField="ngModel" id="vimeoIDField" required name="vimeoIDField"
                    autocomplete="off" name="vimeoID" [(ngModel)]="vimeoID" minlength="3">
                  <!-- <span class="text-danger" *ngIf="( formeditnoisecatalog.submitted) && vimeoIDField.errors?.required">
                  *Required
                </span> -->
                  <span *ngIf="vimeoIDField.touched && vimeoIDField.errors?.minlength">
                    <br /><small style="color: red">Min. length 3 characters</small>
                  </span>
                </div>
              </div>
            </div>
            <!-- Reactivate or Deactivate document  -->
            <div  class="flex-container" style="margin-top: 20px">
              <div class="cms-modal-select-make-checkbox">
                <label class="container sm" *ngIf="isDocActive===false || isDocActive===null">Reactivate
                  <input type="checkbox" id="reactivateOTV" name="reactivateOTV" value="reactivate"
                    [(ngModel)]='reactivate' (change)='setReactivate($event)' [disabled]='isDocActive==true'>
                  <span class="checkmark"></span>
                </label>
                <label class="container sm" *ngIf="isDocActive===true">Deactivate
                  <input type="checkbox" id="deactivateOTV" name="deactivateOTV" value="deactivate"
                    [(ngModel)]='deactivate' (change)='setDeactivate($event)' [disabled]='isDocActive==false'>
                  <span class="checkmark"></span>
                </label>
                <!-- <label class="container sm" style="margin-right:0em;width:10em">Deactivate
                  <input type="radio" id="deactivateOTV" name="deactivateOTV" value="deactivate"
                    [(ngModel)]='reactivateOrDeactivate' [disabled]='isDocActive==false'>
                  <span class="checkmark"></span>
                </label> -->
              </div>
            </div>
            <div  class="flex-container">
              <div class="bmw-cms-modal-button new-bulletin">
                <!-- <button [disabled]='!inputMake' class="bmw-button-secondary" (click)='submit()'>Submit</button> -->
                <span *ngIf="errorMessage!==''"><small style="color: red;text-align: left;">
                    <p text-align: left>&nbsp;&nbsp;{{ errorMessage }}</p>
                  </small></span>
                <span
                  *ngIf="formeditnoisecatalog.touched && formeditnoisecatalog.invalid && inputMake!==null && formeditnoisecatalog.submitted"><small
                    style="color: red;text-align: left;">
                    <p text-align: left>Please enter all mandatory fields.</p>
                  </small></span>
                <button [disabled]='!inputMake' class="bmw-button-secondary" type="submit">Submit</button>
                <!-- <span ><small style="color: red">{{formeditnoisecatalog.pristine}}</small></span>
              <span ><small style="color: red">{{formeditnoisecatalog.touched}}</small></span>
              <span ><small style="color: red">{{formeditnoisecatalog.dirty}}</small></span> -->
              </div>
            </div>
            <!-- <div  class="flex-container"> -->
            <!-- <div class="bmw-cms-modal-button new-bulletin" (mouseenter)="mouseoverLogin=true"
              (mouseleave)="mouseoverLogin=false">
              <button (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false"
                [disabled]='formeditnoisecatalog.invalid' class="bmw-button-secondary">Submit</button>
            </div> -->
            <!-- <div class="bmw-cms-modal-button new-bulletin">
              <span (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false">
                <button mat-raised-button (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false"
                  color="primary" class="btn btn-primary search-btn"
                  [disabled]="formeditnoisecatalog.invalid">Submit</button>
              </span>
            </div> -->
            <!-- </div> -->
          </div>
        </div>
        <!-- <pre>{{formeditnoisecatalog.value | json}}</pre>
        <pre>{{inputMake | json}}</pre> -->
      </form>

    </div>
  </div>
</div>